module.exports = __webpack_public_path__ + "static/media/LEVEL4_PROGRESS.c4f12a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/LEVEL4_PROGRESS.png
// module id = 247
// module chunks = 0